// extracted by mini-css-extract-plugin
export default {"bymaClock":"BymaClock_bymaClock__Rgth8"};